import { useState } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Switch } from "@mui/material";

export default function ConfirmRightButtonModalSwitch2(props) {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.onChange(event.target.checked);
  };
  return (
    <>
      <FormControlLabel
        control={<Switch checked={checked} onChange={handleChange} name="gilad" />}
        label={"Toimitusvalmiss"}
      />
    </>
  );
}

ConfirmRightButtonModalSwitch2.propTypes = {
  onChange: PropTypes.func,
};
